class RegionBrandSelectionBlock {
	constructor() {
		this.container = document.querySelector('.region-brand-selection');

		if (this.container) {
			this.regionTabs = this.container.querySelectorAll('.js-region-tab');
			this.brandSections = this.container.querySelectorAll('.brands-section');
			this.tabWrappers = this.container.querySelectorAll('.tab-wrapper');

			if (this.regionTabs.length > 0) {
				this.init();
			}
		}
	}

	init() {
		this.regionTabs.forEach(tab => {
			tab.addEventListener('click', (e) => this.handleTabClick(e));
		});
	}

	handleTabClick(event) {
		const clickedTab = event.currentTarget;
		const selectedRegion = clickedTab.dataset.region;

		// Update tab styling
		this.updateTabStyling(clickedTab);

		// Show selected region's brands
		this.showBrandSection(selectedRegion);
	}

	updateTabStyling(activeTab) {
		// Remove active class from all tab wrappers
		this.tabWrappers.forEach(wrapper => {
			wrapper.classList.remove('active');
		});

		// Add active class to clicked tab's wrapper
		const activeWrapper = activeTab.closest('.tab-wrapper');
		if (activeWrapper) {
			activeWrapper.classList.add('active');
			$('.brand-logo-container img').hide().fadeIn();
		}
	}

	showBrandSection(selectedRegion) {
		// Hide all brand sections
		this.brandSections.forEach(section => {
			section.classList.remove('active');
		});

		// Show selected region's brands
		const selectedSection = document.querySelector(`.brands-section[data-region="${selectedRegion}"]`);
		if (selectedSection) {
			selectedSection.classList.add('active');
		}
	}
}